var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.tournament === 'ATP')?_c('font-awesome-icon',{attrs:{"icon":"gem"}}):_vm._e(),(_vm.tournament === 'ATP')?_c('span',[_vm._v(" / ")]):_vm._e(),_c('font-awesome-icon',{attrs:{"icon":_vm.tournamentCssIconClass}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69c667e7","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./src/app/components/FilterRow/TournamentDropdown/TournamentIcon/TournamentIcon.html
// module id = null
// module chunks = 